//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Styles
import {
    Container, 
    Content 
} from "./styles";
//#endregion
//#region Images
import userIconImg from "./img/user-icon.svg";
//#endregion
//#region Components
import LogoutButton from "./components/Logout/LogoutButton/LogoutButton"
import NotificationButton from "./components/NotificationButton/NotificationButton"
//#endregion
import useDashboardContext from "routes/utils/context/useDashboardContext";

const Profile = ({ 
    openLogoutOptions
 }) => {
    const { user } = useDashboardContext(); 
    const [firstName, setFirstName] = useState("-");
    useEffect(() => {
        setFirstName(user.name.split(" ")[0]);
    }, [user]);
    return (
        <Container>
            <NotificationButton/>
            <Content>
                <div className="text">
                    <h4 className="name">Hola, <span>{firstName}</span></h4>
                    <h5 className="role">{user.role.name}</h5>
                </div>
                <img src={userIconImg} alt={user.role.name}/>
                <LogoutButton openLogoutOptions={openLogoutOptions}/>
            </Content>
        </Container>
    );
}

export default Profile;